import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ backgroundImage }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <p className={styles.title}>
          <b>А ти знаєш,</b>
          <br></br> що за QR-кодом в середині пачки знаходиться багато контенту,
          який ми створюємо для тебе?
        </p>
        <p className={styles.subTitle}>За QR-кодом можна:</p>
        <img
          src={getImageFromS3('/images/sms-sp1/opportunities.png')}
          alt="opportunities"
          className={styles.opportunitiesImage}
        />
        <p className={styles.opportunitiesTitle}>
          <b>... і ще багато цікавого контенту,</b>
          <br></br>
          який далі ти можеш перевірити самостійно
        </p>
        <img
          src={getImageFromS3('/images/sms-sp1/step1.png')}
          alt="step1"
          className={styles.firstStepImage}
        />
        <div className={styles.firstStepContainerWrapper}>
          <div className={styles.firstStepContainer}>
            <p>Крок 1</p>
            <p>
              <b>Відскануй QR</b> всередині пачки
            </p>
          </div>
        </div>
        <div className={styles.secondContainer}>
          <img src={getImageFromS3('/images/sms-sp1/step2.png')} alt="step2" />
          <div className={styles.textContainer}>
            <p>Крок 2</p>
            <p>
              <b>Пройди верифікацію віку</b> за допомогою камери
            </p>
          </div>
        </div>
        <div className={styles.thirdContainer}>
          <div className={styles.textContainer}>
            <p>Крок 3</p>
            <p>
              <b>Пройди реєстрацію,</b> або пропустити, якщо вже зареєстрований
            </p>
          </div>
          <img src={getImageFromS3('/images/sms-sp1/step3.png')} alt="step3" />
        </div>
        <div className={styles.fourthContainer}>
          <img src={getImageFromS3('/images/sms-sp1/step4.png')} alt="step4" />
          <div className={styles.textContainer}>
            <p>Крок 4</p>
            <p>
              <b>Відкривай контент,</b> який ми створили для тебе
            </p>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-sp1">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
